export enum MeshTypeEnum {
    TOOL,
    HANDLE,
    ENTITY
}